import { Fragment } from 'react'
import { useMatch, useNavigate } from 'react-router-dom'
import { Box, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, ListSubheader } from '@mui/material'
import { DEFAULT_SETTINGS_SECTION_ID } from '@/data/settingsNavData'
import { buildSettingsSectionPath } from '@/routes/paths'
import { fluentIconWrapperSx } from '@/theme/sx/fluentIconWrapperSx.js'
import { settingsItemButtonSx, settingsItemIconSx, settingsItemTextPrimarySx, settingsSubheaderSx } from './settingsSectionSx.js'

export function SettingsSectionNavList({ filteredGroups, activeSectionId: activeSectionIdProp, onSectionSelect }) {
  const navigate = useNavigate()
  const routeSectionId =
    useMatch({ path: '/settings/:sectionId', end: true })?.params?.sectionId ?? DEFAULT_SETTINGS_SECTION_ID
  const activeSectionId = activeSectionIdProp ?? routeSectionId

  return (
    <List disablePadding dense sx={{ width: '100%', py: 0 }}>
      {filteredGroups.map((group, groupIndex) => (
        <Fragment key={group.id}>
          {groupIndex > 0 ? (
            <Divider component="li" role="separator" sx={{ borderColor: '#e8ded6', my: 0.5, listStyle: 'none' }} />
          ) : null}
          <ListSubheader component="div" id={`${group.id}-label`} sx={settingsSubheaderSx}>
            {group.label}
          </ListSubheader>
          {group.items.map((item) => {
            const Icon = item.Icon
            const selected = item.id === activeSectionId
            return (
              <ListItem key={item.id} disablePadding sx={{ display: 'block' }}>
                <ListItemButton
                  dense
                  selected={selected}
                  onClick={() =>
                    onSectionSelect ? onSectionSelect(item.id) : navigate(buildSettingsSectionPath(item.id))
                  }
                  sx={settingsItemButtonSx}
                  aria-label={item.label}
                  aria-current={selected ? 'page' : undefined}
                >
                  <ListItemIcon sx={settingsItemIconSx}>
                    <Box component="span" sx={fluentIconWrapperSx(18)} aria-hidden>
                      <Icon />
                    </Box>
                  </ListItemIcon>
                  <ListItemText primary={item.label} slotProps={{ primary: { sx: settingsItemTextPrimarySx } }} />
                </ListItemButton>
              </ListItem>
            )
          })}
        </Fragment>
      ))}
    </List>
  )
}
